// extracted by mini-css-extract-plugin
export default {"serviceDescription":"QILwj","descriptionWrapper":"eCMB4","connected":"Kp2zp","familyPicture":"l1Oa6"};